<template>
    <sweet-modal :title="$t('modal_addUsers')" blocking ref="editTaskList" v-on:close="editTaskListClose">
        <el-form :model="editTaskList" status-icon ref="form">
                    <el-form-item prop="editTaskTeamId">
                        <el-select no-data-text="no date" v-model="editTaskList.editedTaskTeamId" multiple :placeholder="$t('modal_addUsers')" style="width:100%;">
                            <el-option-group
                                    class="select-group"
                                    v-for="group in editTaskList.editedTaskTeam"
                                    :key="group.id"
                                    :label="group.label">
                                <el-option
                                        v-for="item in group.children"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
            <el-form-item>
                <el-button @click="editTaskListSubmit" class="modal__btn" type="primary" plain size="mini">{{$t('general_add')}}</el-button>
            </el-form-item>
        </el-form>
    </sweet-modal>
</template>

<script>
  import axios from 'axios';
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

  export default {
    name: 'AddUsersToTasksModal',
    components: {
      Treeselect,
      SweetModal
    },
    props:['selectedRows','activeProjectId'],
    data () {
      return {
        editTaskList:{
          changeEditedTaskTeam: true,
          editAssignedTo: [],
          editedTaskTeam: [],
          editedTaskTeamId: []
        },
        usersList: []
      }
    },
    methods: {
      addNewUsersOpen(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectTasks/directories?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&operation=updateList`)
          .then(response => {
            var result = [];
            for (var index = 0; index < response.data.businessUnitList.length; index++) {
              var businessUnit = response.data.businessUnitList[index];
              var children = [];
              for (var index2 = 0; index2 < response.data.companyUserList.length; index2++) {
                var companyUser = response.data.companyUserList[index2];
                if (companyUser.businessUnitId == businessUnit.id) {
                  children.push({
                    id: companyUser.id,
                    label: companyUser.user.fullName,
                    status: companyUser.status
                  })
                }
              }
              // if (children.length > 0) {
              result.push({
                // id: businessUnit.id,
                id: businessUnit.name,
                label: businessUnit.name,
                children: children,
              })
              // }
            }
            console.log('---DDDDDDDDDDDDDDDDDDDD', result);

            this.editTaskList.editedTaskTeam = result;
            this.$refs.editTaskList.open();
            this.usersList = response.data.companyUserList;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      editTaskListClose(){
        this.editTaskList.editAssignedTo = [];
        this.editTaskList.editedTaskTeam = [];
        this.editTaskList.editedTaskTeamId = [];
        this.usersList = []
      },
      editTaskListSubmit(){
        let projectTaskIdList = [];
        for (let i = 0; i < this.selectedRows.length; i++){
          projectTaskIdList.push(this.selectedRows[i].id)
        }
        let loader = this.$loading.show();
        axios
          .post(`/api/v1/projectTasks/addNewUsersList?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`, {
            projectTaskIdList: projectTaskIdList,
            changeCompanyUserList: this.editTaskList.changeEditedTaskTeam,
            companyUserIdList: this.editTaskList.editedTaskTeamId,
          })
          .then(response => {
            this.$refs.editTaskList.close();
            this.notification(this.$t('general_success'), this.$t('modal_usersAddedSuccessfully'), "success");
            loader.hide();
            // TODO
            // this.setProjectRowData(id)
            this.$emit('submit', this.activeProjectId, 'first')
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
